import React, {Component} from 'react';
import debounce from 'lodash/debounce';
import template from './SitesHeader.rt';

export default class SitesHeader extends Component {

  constructor(props) {
    super(props);

    this.state = {
      searchKeyword: ''
    }

    this.debouncedGetSites = debounce(props.getSites, 250);
  }

  handleSearch = (keyWord) => {
    this.setState({searchKeyword: keyWord}, () => {
      this.debouncedGetSites(0, keyWord, this.state.sortKeyword, this.state.sortOrder);
    });
  }

  render = template
}

